import { withRouter } from 'react-router-dom';
import Singlechips from "./Singlechips.js";
import WithSystem from './../service/WithSystem';
const dataJson = JSON.parse(`{"limit":5,"courses":${window.courseNamesFilter}}`);
const branchesJson = JSON.parse(`{"limit":5,"courses":${window.branchFilter}}`);
const batchesJson = JSON.parse(`{"limit":5,"courses":${window.batchFilter}}`);
const gradesJson = JSON.parse(`{"limit":5,"courses":${window.gradeFilter}}`);
const certificatereleaseJson = JSON.parse(`{"limit":5,"courses":${window.certificaterelease}}`);
const facultyJson = JSON.parse(`{"limit":5,"courses":${window.facultyFilter}}`);
class FilterChips extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  removeChips = (param = false) => {
    if (param) {
      let key = param.key;
      switch (key) {
        case 'selectedCourse':
          let removedValueCourse = param.value;
          let previewSelectedCourse = this.props.queryFilter.selectedCourse ?? false;
          previewSelectedCourse = previewSelectedCourse ? previewSelectedCourse.split(',') : [];
          let selectedCourse = previewSelectedCourse.filter((previewItem) => removedValueCourse != previewItem);
          selectedCourse = selectedCourse.length ? selectedCourse.join() : false;
          this.props.setGlobalState({ selectedCourse });
          break;
        case 'branches':
          let removedValuebranch = param.value;
          document.getElementById(`branch_${removedValuebranch}`).checked = false;
          let previewBranches = this.props.queryFilter.branches ?? false;
          previewBranches = previewBranches ? previewBranches.split(',') : [];
          let branches = previewBranches.filter((previewItem) => removedValuebranch != previewItem);
          branches = branches.length ? branches.join() : false;
          this.props.setGlobalState({ branches });
          break;
        case 'batches':
          let removedValuebatch = param.value;
          document.getElementById(`batch_${removedValuebatch}`).checked = false;
          let previewBatches = this.props.queryFilter.batches ?? false;
          previewBatches = previewBatches ? previewBatches.split(',') : [];
          let batches = previewBatches.filter((previewItem) => removedValuebatch != previewItem);
          batches = batches.length ? batches.join() : false;
          this.props.setGlobalState({ batches });
          break;
        case 'certificate':
          let removedValuecertificate = param.value;
          document.getElementById(`cerreleased_${removedValuecertificate}`).checked = false;
          let previewCertificates = this.props.queryFilter.certificate ?? false;
          previewCertificates = previewCertificates ? previewCertificates.split(',') : [];
          let certificate = previewCertificates.filter((previewItem) => removedValuecertificate != previewItem);
          certificate = certificate.length ? certificate.join() : false;
          this.props.setGlobalState({ certificate });
          break;
        case 'searchkey':
          let searchkey = false;
          this.props.setGlobalState({ searchkey });
          break;
        case 'enddate':
          document.getElementById(`date-range-1`).value = '';
          let enddate = false;
          let startdate = '';
          let removed = true;
          window.refreshDateRangePicker = 1;
          this.props.setGlobalState({ startdate, enddate ,removed});
          break;
        case 'comenddate':
          document.getElementById(`date-range`).value = '';
          let comenddate = false;
          let comstartdate = false;
          let removeddate = true;
          window.refreshDateRangePicker = 2;
          this.props.setGlobalState({ comstartdate, comenddate, removeddate });
          break;
        case 'maxProgressRange':
          let minProgressRange = false;
          let maxProgressRange = false;
          this.props.setGlobalState({ minProgressRange, maxProgressRange });
          break;
        case 'progressstatus':
          window.clearProgress = true;
          let progressstatus = false;
          this.props.setGlobalState({ progressstatus });
          break;
        case 'grades':
          let removedValuegrades = param.value;
          document.getElementById(`grade_${removedValuegrades}`).checked = false;
          let previewGrades = this.props.queryFilter.grades ?? false;
          previewGrades = previewGrades ? previewGrades.split(',') : [];
          let grades = previewGrades.filter((previewItem) => removedValuegrades != previewItem);
          grades = grades.length ? grades.join() : false;
          this.props.setGlobalState({ grades });
          break;
        case 'faculties':
          let removedValuefaculty = param.value;
          document.getElementById(`faculty_${removedValuefaculty}`).checked = false;
          let previewFaculty = this.props.queryFilter.faculties ?? false;
          previewFaculty = previewFaculty ? previewFaculty.split(',') : [];
          let faculties = previewFaculty.filter((previewItem) => removedValuefaculty != previewItem);
          faculties = faculties.length ? faculties.join() : false;
          this.props.setGlobalState({ faculties });
          break;
        default:
          break;
      }
    }
  }
  allClear = () => {
    this.props.setGlobalState({ 'searchkey': false, 'startdate': false, 'enddate': false, 'selectedCourse': false, 'branches': false, 'batches': false, 'comstartdate': false, 'comenddate': false, 'grades': false, 'certificate': false, 'maxProgressRange': false, 'minProgressRange': false, 'progressstatus': false, 'faculties': false });
    window.refreshDateRangePicker = 2;
    window.clearProgress = true;
    window.uncheckAllcheckbox();
  }
  render() {
    let renderchips              = [];
    let setStartdate             = false;
    let setComStartdate          = false;
    let setminProgressRange      = '0';
    let selectedCourses          = [];
    let selectedBranches         = [];
    let selectedBatches          = [];
    let selectedGrades           = [];
    let selectedItems            = [];
    let selectedBranchesItems    = [];
    let selectedBatchesItems     = [];
    let selectedGradeItems       = [];
    let selectedCertificateItems = [];
    let selectedFacultiesItems   = [];
    let selectedFaculties        = [];
    for (const [key, value] of Object.entries(this.props.queryFilter)) {
      if (key == 'certificate' && value != false && value != '' && value != undefined) {
        selectedCourses = value.toString().split(',');
        certificatereleaseJson.courses.map((course) => {
          if (selectedCourses.includes(course.id)) {
            selectedCertificateItems.push({ id: course.id, cb_title: course.name, cb_price: course.name, });
          }
        });
        for (var i = 0; i < selectedCertificateItems.length; i++) {
          renderchips.push(<Singlechips key={`certificate_${selectedCertificateItems[i]['id']}`} label={{ 'name': `${selectedCertificateItems[i]['cb_title']}`, 'value': `${selectedCertificateItems[i]['id']}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
        }
      }
      if (key == 'selectedCourse' && value != false && value != '' && value != undefined) {
        selectedCourses = value.toString().split(',');
        dataJson.courses.map((course) => {
          if (selectedCourses.includes(course.id)) {
            selectedItems.push({ id: course.id, cb_title: course.cb_title, cb_price: course.cb_price, });
          }
        });
        for (var i = 0; i < selectedItems.length; i++) {
          renderchips.push(<Singlechips key={`selectedCourse_${selectedItems[i]['id']}`} label={{ 'name': `${selectedItems[i]['cb_title']}`, 'value': `${selectedItems[i]['id']}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
        }
      }
      if (key == 'branches' && value != false && value != '' && value != undefined) {
        selectedCourses = [];
        selectedBranches = value.toString().split(',');
        branchesJson.courses.map((course) => {
          if (selectedBranches.includes(course.id)) {
            selectedBranchesItems.push({ id: course.id, cb_title: course.ib_name, cb_price: course.ib_institute_code, });
          }
        });
        for (var i = 0; i < selectedBranchesItems.length; i++) {
          renderchips.push(<Singlechips key={`branches_${selectedBranchesItems[i]['id']}`} label={{ 'name': `${selectedBranchesItems[i]['cb_title']}`, 'value': `${selectedBranchesItems[i]['id']}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
        }
      }
      if (key == 'batches' && value != false && value != '' && value != undefined) {
        selectedCourses = [];
        selectedBatches = value.toString().split(',');
        batchesJson.courses.map((course) => {
          if (selectedBatches.includes(course.id)) {
            selectedBatchesItems.push({ id: course.id, cb_title: course.gp_name, cb_price: course.gp_institute_code, });
          }
        });
        for (var i = 0; i < selectedBatchesItems.length; i++) {
          renderchips.push(<Singlechips key={`batches_${selectedBatchesItems[i]['id']}`} label={{ 'name': `${selectedBatchesItems[i]['cb_title']}`, 'value': `${selectedBatchesItems[i]['id']}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
        }
      }
      if (key == 'grades' && value != false && value != '' && value != undefined) {
        selectedCourses = [];
        selectedGrades = value.toString().split(',');
        gradesJson.courses.map((course) => {
          if (selectedGrades.includes(course.gr_name)) {
            selectedGradeItems.push({ id: course.gr_name, cb_title: course.gr_name, cb_price: course.gr_name, });
          }
        });
        for (var i = 0; i < selectedGradeItems.length; i++) {
          renderchips.push(<Singlechips key={`grades_${selectedGradeItems[i]['id']}`} label={{ 'name': `${selectedGradeItems[i]['cb_title']}`, 'value': `${selectedGradeItems[i]['id']}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
        }
      }
      /*if (key == 'searchkey' && key != false && value != '' && value != undefined) {
       renderchips.push(<Singlechips key={`searchkey_001`} label={{ 'name': `Search Key : ${value}`, 'value': `Search Key : ${value}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
      }*/
      if (key == 'startdate' && key != false && value != '' && value != undefined) {
        setStartdate = value;
      }
      if (key == 'enddate' && setStartdate != false && key != false && value != '' && value != undefined) {
        renderchips.push(<Singlechips key={`enddate_001`} label={{ 'name': `Date of Enrollment : ${value} - ${setStartdate}`, 'value': `Date of Enrollment : ${value}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
      }
      if (key == 'comstartdate' && key != false && value != '' && value != undefined) {
        setComStartdate = value;
      }
      if (key == 'comenddate' && setComStartdate != false && key != false && value != '' && value != undefined) {
        renderchips.push(<Singlechips key={`comenddate_001`} label={{ 'name': `Date of completion : ${value} - ${setComStartdate}`, 'value': `Date of completion : ${value}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
      }
      if (key == 'minProgressRange' && key != false && value != '' && value != undefined) {
        setminProgressRange = value;
      } 
      if (key == 'maxProgressRange' && key != false && value != '' && value != undefined) {
        renderchips.push(<Singlechips key={`progress_001`} label={{ 'name': `Course Progress : ${setminProgressRange} - ${value}`, 'value': `Course Progress : ${value}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
      }
      if (key == 'progressstatus' && key != false && value != '' && value != undefined) {
        renderchips.push(<Singlechips key={`progress_001`} label={{ 'name': `${value}`, 'value': `${value}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
      }
      if (key == 'faculties' && value != false && value != '' && value != undefined) {
        selectedCourses = [];
        selectedFaculties = value.toString().split(',');
        facultyJson.courses.map((course) => {
          if (selectedFaculties.includes(course.id)) {
            selectedFacultiesItems.push({ id: course.id, cb_title: course.us_name, cb_price: course.us_name, });
          }
        });
        for (var i = 0; i < selectedFacultiesItems.length; i++) {
          renderchips.push(<Singlechips key={`faculties_${selectedFacultiesItems[i]['id']}`} label={{ 'name': `${selectedFacultiesItems[i]['cb_title']}`, 'value': `${selectedFacultiesItems[i]['id']}`, 'selectedKey': `${key}` }} removeChips={this.removeChips} />);
        }
      }
    }
    return (
      (queryFilter['searchkey'].length>0 || renderchips.length != 0) && <div className="leaner-filter-sld-sec show">
        <div className="container-fluid">
          <div className="filter-sltd-innersc">
            <ul>
              {renderchips}
            </ul>
            {(queryFilter['searchkey'].length>0 || renderchips.length != 0) && <div className="clear-filtertxt" onClick={this.allClear}  >Clear</div>}
          </div>
        </div>
      </div>
    )
  }
}
export default WithSystem(FilterChips);